import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import SiteHeader from "../../components/SiteHeader";
import SiteFooter from "../../components/SiteFooter";

const INDEX_HERO = "https://images.unsplash.com/photo-1673515335048-ace62cf73a26?w=1200&q=80";
const INDEX_HERO_CREDIT = "Ling App";


export default function GuidesIndexPage() {
  const [guides, setGuides] = useState([]);

  useEffect(() => {
    api.get("/guides").then((r) => setGuides(r.data)).catch(() => {});
  }, []);

  return (
    <div className="bg-[#111111] min-h-screen">
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .guide-card { animation: fadeInUp 0.5s ease both; }
        .guide-card:nth-child(1) { animation-delay: 0s; }
        .guide-card:nth-child(2) { animation-delay: 0.1s; }
        .guide-card:nth-child(3) { animation-delay: 0.2s; }
        .guide-card-img { transition: transform 0.3s ease; }
        .guide-card:hover .guide-card-img { transform: scale(1.05); }
      `}</style>
      <Helmet>
        <title>Flight Deal Guides – Restricted Deals</title>
        <meta name="description" content="Free guides on finding cheap flights, booking mistake fares, and getting the best travel deals from Europe and beyond." />
        <link rel="canonical" href="https://restricteddeals.com/guides" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://restricteddeals.com/guides" />
        <meta property="og:title" content="Flight Deal Guides – Restricted Deals" />
        <meta property="og:description" content="Free guides on finding cheap flights, booking mistake fares, and getting the best travel deals from Europe and beyond." />
        <meta property="og:image" content={INDEX_HERO} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Flight Deal Guides – Restricted Deals" />
        <meta name="twitter:description" content="Free guides on finding cheap flights, booking mistake fares, and getting the best travel deals from Europe and beyond." />
        <meta name="twitter:image" content={INDEX_HERO} />
      </Helmet>
      <SiteHeader />

      {/* Hero */}
      <div>
        <div style={{ position: "relative", height: 320, overflow: "hidden" }}>
          <img
            src={INDEX_HERO}
            alt="Travel language learning"
            style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "center", display: "block" }}
          />
          <div style={{
            position: "absolute", inset: 0,
            background: "linear-gradient(to bottom, rgba(0,0,0,0.35), rgba(17,17,17,0.9))",
            display: "flex", flexDirection: "column", justifyContent: "flex-end",
            padding: "2rem clamp(1rem, 5vw, 4rem)",
          }}>
            <p className="eyebrow eyebrow-red mb-2">// GUIDES</p>
            <h1 className="font-mono text-4xl md:text-5xl text-white uppercase tracking-tight">
              Flight Deal Guides
            </h1>
          </div>
        </div>
        <p style={{ fontFamily: "monospace", fontSize: "10px", color: "#444444", textAlign: "right", margin: "4px 8px 0 0" }}>
          Photo by {INDEX_HERO_CREDIT} on Unsplash
        </p>
      </div>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <p className="text-[#9A8F83] font-sans mb-12 leading-relaxed">
          Practical guides on finding cheap flights, booking mistake fares, and getting the best deals before they disappear.
        </p>

        <div className="space-y-6">
          {guides.map((g) => (
            <Link
              key={g.slug}
              to={`/guides/${g.slug}`}
              className="guide-card block overflow-hidden border border-[#2A2A2A] hover:border-[#CC1A1A] transition-colors group"
              style={{ textDecoration: "none" }}
            >
              {/* Image */}
              {g.hero_image && (
                <div style={{ height: 200, overflow: "hidden", position: "relative" }}>
                  <img
                    src={g.hero_image}
                    alt={g.title}
                    className="guide-card-img"
                    style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "center", display: "block" }}
                  />
                  <div style={{
                    position: "absolute", inset: 0,
                    background: "linear-gradient(to top, rgba(14,14,14,0.85) 0%, rgba(0,0,0,0.1) 60%)",
                  }} />
                </div>
              )}
              {/* Text */}
              <div className="bg-[#0E0E0E] p-5">
                <h2 className="font-mono text-base text-white uppercase tracking-tight group-hover:text-[#CC1A1A] transition-colors mb-2">
                  {g.title}
                </h2>
                {g.meta_description && (
                  <p className="text-[#9A8F83] font-sans text-sm leading-relaxed">{g.meta_description}</p>
                )}
                <p className="mt-4 text-[11px] font-mono tracking-[0.15em] uppercase text-[#CC1A1A]">READ GUIDE →</p>
              </div>
            </Link>
          ))}
        </div>

        <div className="hr-dot my-10" />
        <div className="flex gap-6 text-[11px] font-mono tracking-widest uppercase text-[#555]">
          <Link to="/" className="hover:text-white transition-colors">Home</Link>
          <Link to="/subscribe" className="hover:text-white transition-colors">Subscribe</Link>
          <Link to="/about" className="hover:text-white transition-colors">About</Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
